import Callout from 'modules/core/components/Callout'
import i18n from 'modules/core/lib/i18n'
import { PayrollRunStatus } from 'modules/compensations/lib/payrollRunStatus'

interface CompensationsNotifiedToProfessionalsCalloutProps {
  payrollRunStatus: string
}

const CompensationsNotifiedToProfessionalsCallout = ({
  payrollRunStatus,
}: CompensationsNotifiedToProfessionalsCalloutProps) => {
  if (payrollRunStatus !== PayrollRunStatus.CALCULATION) return null

  return (
    <Callout
      type="info"
      compact
      description={i18n.t('bookkeepers.clients.payroll_cycles.notify_professionals_callout')}
    />
  )
}

export default CompensationsNotifiedToProfessionalsCallout
